/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const emotionalEating = useStore((state) => state.emotionalEating);
  const setEmotionalEating = useStore((state) => state.setEmotionalEating);
  const [next, setNext] = useState(emotionalEating.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setEmotionalEating(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.emotionalEating.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={emotionalEating} onChange={handleChange}>
          <MultiOption value={"When I'm bored"}>
            <span>😴</span> {t('onboarding.emotionalEating.options.bored')}
          </MultiOption>
          <MultiOption value={"When I'm stressed"}>
            <span>😫</span> {t('onboarding.emotionalEating.options.stressed')}
          </MultiOption>
          <MultiOption value={"When I'm tired"}>
            <span>💤</span> {t('onboarding.emotionalEating.options.tired')}
          </MultiOption>
          <MultiOption value={"When I'm sad"}>
            <span>😔</span> {t('onboarding.emotionalEating.options.sad')}
          </MultiOption>
          <MultiOption value={'When I see food'}>
            <span>🍪</span> {t('onboarding.emotionalEating.options.seeFood')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.emotionalEating.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'emotional-eating',
              answer: emotionalEating.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
